import React, { createRef, useEffect, useState } from "react";
import FeedMessage from "./FeedMessage";
import $ from 'jquery'
import ReactDynamicModal from "react-draggable-resizable-modal";
import SkeletonMessageFeed from "../../../loaders/SkeletonMessageFeed";
import { GetSupportTeamService } from "../../../services/PostsAndFeedService";
import { useRef } from "react";
import moment from "moment";
import { TABLE_DATE_FORMAT } from "../../../utils/Constants";

const FeedMessages = (props) => {

  const [videoArr, setVideoArr] = useState([]);
  const [currentVideo, setCurrentVideo] = useState('');
  const [modalOpen, setModalOpen] = useState(false)
  const [loader, setLoader] = useState(true);
  const [dateArr, setDateArr] = useState([]);
  const [noOfLoader, setNoOfLoader] = useState(2)
  const [hideList, setHideList] = useState("");
  const [team, setTeam] = useState([]);
  const [teamObj, setTeamObj] = useState([]);
  const [classData, setClassData] = useState([]);

  const closeModal = () => {
    setModalOpen(false);
    setCurrentVideo('')
  };

  useEffect(() => {
    setLoader(true)
    dateMethod();
    const t = setTimeout(() => {
      setLoader(false)
    }, 1000);
    return () => {clearTimeout(t)}
  }, [props.feeds.length])
  
  const dateMethod = () => {
    let tempArr = []
    props.feeds.map((item) => {
      let dateOnly = moment(item.updated_at, "Do MMMM YYYY, h:mm:ss a").format(TABLE_DATE_FORMAT)
      if (!tempArr.includes(dateOnly)) {
        tempArr.push(dateOnly)
      } else {
        tempArr.push("")
      }      
    })
    setDateArr(tempArr)
  }

  useEffect(() => {
    let mounted = true
    GetSupportTeamService({ room_id: props.roomId })
      .then((res) => {
        if (mounted) {
          setTeam(res.data.team);
          if (res.data.team) {
            let tempObj = Object.keys(res.data.team).map(item => {
              return {
                ...res.data.team[item], role: item
              }
            });
          setTeamObj(tempObj)
          }
        }
      })
      .catch((error) => { });

    return function cleanup() {
      mounted = false
    }
  }, []);

  const childRef = useRef({});
  const openIdRef = useRef(null);

  const clickOutsideHandle = (event) => {
    const target = event.target;
    const replyElem = target.closest('.reply-static');
    const editElem = target.closest('.main_thread_edit');
    const replyBoxElem = target.closest('.ps-by-card-footer');

    if (editElem) {
      return;
    }

    if (replyBoxElem) {
      return;
    }

    // Close any open editor
    if (openIdRef.current !== null) {
      const child = childRef.current[openIdRef.current];
      if (child) {
        // Trying to reset using the specific method
        if (child.resetReplyEditor) {
          child.resetReplyEditor();
        } else if (child.handleClickOutside) {
          child.handleClickOutside({ target: document.body, forceClose: true });
        }
      }
      openIdRef.current = null;
    }

    // Now open the new one if clicking on reply
    if (replyElem) {
      const id = replyElem.id;
      if (id) {
        const child = childRef.current[id];
        if (child?.handleClickOutside) {
          child.handleClickOutside(event);
        }
        openIdRef.current = id;
      }
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", clickOutsideHandle,true);
    return () => {
      document.removeEventListener("mousedown", clickOutsideHandle, true);
    };
  }, []);

  return (
    <>
      <div className="chat-msg-container ps-fd-card-body chat-space-lt" id='contenttwo'>
        {(props.loadMore) && <SkeletonMessageFeed count={noOfLoader} />}
        {props.feeds.map((feed, index) => {
          return (
            <FeedMessage
              ind={index}
              islastIndex={(props.feeds.length-1)==index}
              key={`${feed.id}-${feed.room_id}-${index}`}
              feed={feed}
              showDate={dateArr[index] ? true : false}
              online={props.online}
              taggingUsers={props.taggingUsers}
              setCurrentVideo={(link) => { setCurrentVideo(link); setModalOpen(true); }}
              updateMsg={props.updateMsg}
              setOpenReplyId={props.setOpenReplyId}
              openReplyId={props.openReplyId}
              setShowHideEdit={props.setShowHideEdit}
              showHideEditArr={props.showHideEditArr}
              setShowHidePostEdit={props.setShowHidePostEdit}
              showHidePostEdit={props.showHidePostEdit}
              resetEditor={props.resetEditor}
              deleteHandle={props.deleteHandle}
              likeDislikeHandle={props.likeDislikeHandle}
              updatePostImportant={props.updatePostImportant}
              sendClick={props.sendClick}
              deletedFile={props.deletedFile}
              reduceCount={props.reduceCount}
              hideList={hideList}
              setHideList={setHideList}
              updateReadMessages={props.updateReadMessages}
              roomId={props.roomId}
              teamObj={teamObj}
              ref={(el) => {
                if (el) {
                  childRef.current[feed.id] = el;
                } else {
                  delete childRef.current[feed.id];
                }
              }}
              setReRender={props.setReRender}
              setRefreshPinnedMsg={props.setRefreshPinnedMsg}
              totalSubmission={props?.totalSubmission}
              classData={classData}
              setClassData={setClassData}
            />
          );
        })}
        <div id='content' />
      </div>

      <div className="modal-update iframe_modal_full">
        <ReactDynamicModal
          data-backdrop="static"
          initWidth={640}
          initHeight={440}
          onRequestClose={closeModal}
          isOpen={modalOpen}

          data={
            <div className="body">
              {currentVideo != '' ?
                <iframe allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen" src={`https://${currentVideo}`} frameborder="0"></iframe>
                :
                null
              }
            </div>
          }
        />
      </div>
    </>
  );
};

export default React.memo(FeedMessages);
